import classNames from 'classnames'
import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CIVILISATION_ID, RARITIES, IPFS_URL } from '../../app/constants'
import { Avatar_5, Marker } from '../../assets/img'
import { getAvatar } from '../../features/avatar/avatarSlice'
import { setPopUp } from '../../features/popUpSlice/popUpSlice'
import useWax from '../../hooks/useWax'
import { PercentageDisplay } from '../containers/PercentageDisplay'
import Button from '../ui/Button'
import AvatarPopup from './AvatarPopup'

const MyStats = ({ civilisation }) => {
  const { claim } = useWax()
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const userCollection = useSelector((state) => state.userCollection)
  const [isOpen, setIsOpen] = useState(false)
  const profile = useSelector((state) => state.profile)
  const fetchAvatars = useSelector((state) => state.avatar.avatars.data)
  const fetchAvatarsCfgs = useSelector((state) => state.avatar.avatarTemplates)
  const allAvatars = useSelector(state => state.avatar.allAvatars.data)
  const avatar_img = profile.currentAvatar?.data?.find( item => item.key === CIVILISATION_ID[civilisation])?.value ?? Avatar_5;
  const avatar_id = profile.currentAvatar?.avatar_asset_ids?.find( item => item.key === CIVILISATION_ID[civilisation])?.value ?? -1;
  const avatar_data = allAvatars?.find(e => e.asset_id === avatar_id);
  const avatar_rarity = avatar_data?.data?.rarity ?? "Titanium";

  const handleClaimGLK = async (event) => {
    event.preventDefault()
    await claim('GLK')
  }
  const handleClaimNFT = async (event) => {
    event.preventDefault()
    await claim('NFT')
  }

  return (
    <>
      <section className="flex flex-wrap justify-around gap-3 p-2 pb-5 mx-auto mt-0 overflow-auto lg:-mt-6 sm:w-11/12 lg:w-full lg:flex-nowrap md:px-2 lg:px-8 xl:px-20 lg:pt-0 xl:pb-8 3xl:pb-12 container__mission--grid">
        <div className="flex items-start justify-between md:flex-col">
          <div className="flex flex-col items-center justify-center w-2/3 pt-3 2xl:w-3/5 md:w-3/4">
            <h3 className="hidden pb-3 text-center text-white lg:block">
              {user.accountName}
            </h3>
            <img
              className="w-full aspect-[66.5/100] object-cover"
              src={
                avatar_img?.startsWith('Q')
                  ? `${IPFS_URL}${avatar_img}`
                  : avatar_img
              }
              alt="Avatar Portrait"
              onClick={() => {
                setIsOpen(true)
              }}
            ></img>
            <Markers rarity={avatar_rarity} className="pt-2" />
          </div>
          <div className="pl-2 lg:pl-0">
            <h3 className="pb-3 text-center text-white lg:hidden">
              {user.accountName}
            </h3>
            <p className="pt-2 text-cyanBlue lg:hidden">
              {avatar_rarity} Level
            </p>
            <p className="text-left text-white ">
              Total NFTs:{' '}
              <span className="text-cyanBlue">
                {userCollection.detailedCollection.length}
              </span>
            </p>
            <p className="pt-1 text-left text-white">
              Total NFT MP:{' '}
              <span className="text-cyanBlue">
                {userCollection.totalMP?.toFixed(2) ?? 0.00}
              </span>
            </p>
            <p className="pt-1 text-left text-white">
              Mission Success: <span className="text-cyanBlue">16</span>
            </p>
            <p className="pt-1 text-left text-white">
              Solar Systems: <span className="text-cyanBlue">0</span>
            </p>
          </div>
        </div>
        <div className="w-full col-span-2 lg:w-full 3xl:pl-12 md:w-1/2">
          {[
            ['GLK', false],
            ['NFTs', true],
          ].map(([title, isMP], _) => (
            <div
              className="grid grid-cols-2 gap-x-3 pt-7 xl:pt-10 3xl:pt-20"
              key={_}
            >
              <div className="flex flex-col justify-between col-span-1 mx-2 lg:mx-5">
                <h3 className="col-span-2 pb-4 text-white ">{title} Staked</h3>
                <div className="grid h-full grid-rows-3 gap-y-3">
                  <p className="self-center text-gold">Mining Mission</p>
                  <p className="self-center text-gold">Exploration</p>
                  <p className="self-center text-gold">Discovery</p>
                </div>
              </div>
              <div className="flex flex-col justify-between col-span-1 xl:mr-10">
                {_ === 0 && (
                  <h3 className="self-center pb-4 text-white">
                    Total GLK staked
                  </h3>
                )}
                <div className="grid grid-rows-3 gap-y-3 ">
                  <PercentageDisplay
                    mission={1}
                    civilization={civilisation}
                    isMP={isMP}
                  />
                  <PercentageDisplay
                    mission={2}
                    civilization={civilisation}
                    isMP={isMP}
                  />
                  <PercentageDisplay
                    mission={3}
                    civilization={civilisation}
                    isMP={isMP}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="flex flex-col items-center w-full col-span-2 overflow-hidden gap-y-3 lg:w-full md:w-1/2">
          <h3 className="text-cyanBlue pt-7 xl:pt-10 3xl:pt-20">
            Unclaimed Rewards
          </h3>
          <Button
            className="w-5/6 xl:lg:w-3/5 "
            onClick={(e) => handleClaimGLK(e)}
            responsive
          >
            Claim GLK Rewards
          </Button>
          <Button
            className="w-5/6 xl:lg:w-3/5"
            onClick={(e) => handleClaimNFT(e)}
            responsive
          >
            Claim NFT Rewards
          </Button>
        </div>
      </section>
      <AvatarPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        avatars={fetchAvatars}
        avatarsTemplates={fetchAvatarsCfgs[civilisation]}
        civilization={civilisation}
        currentAvatar={{id: avatar_id, img: avatar_img}}
      />
    </>
  )
}

const Markers = ({ className, rarity = RARITIES[0] }) => {
  const totalMarkers = 7
  const rarityValue = RARITIES.indexOf(rarity) + 1
  const unfilled = totalMarkers - rarityValue
  return (
    <>
      <div className={classNames(className, 'flex gap-1')}>
        {[
          ...Array(rarityValue).fill(
            <Marker fill="currentColor" className="bg-gold text-gold " />,
          ),
        ].map((e, i) => (
          <span key={i}>{e}</span>
        ))}
        {[
          ...Array(unfilled).fill(<Marker className="bg-gold text-gold" />),
        ].map((e, i) => (
          <span key={i}>{e}</span>
        ))}
      </div>
      <p className="hidden pt-2 text-cyanBlue lg:block">{rarity} Level</p>
    </>
  )
}

export default MyStats
